var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clock",
    clipPath: "url(#clip0_743_7248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.75 3.9375V3.1875H6.25V3.9375H7.75ZM7 7H6.25V7.75H7V7ZM10.0625 7.75H10.8125V6.25H10.0625V7.75ZM11.9375 7C11.9375 9.72691 9.72691 11.9375 7 11.9375V13.4375C10.5553 13.4375 13.4375 10.5553 13.4375 7H11.9375ZM7 11.9375C4.27309 11.9375 2.0625 9.72691 2.0625 7H0.5625C0.5625 10.5553 3.44467 13.4375 7 13.4375V11.9375ZM2.0625 7C2.0625 4.27309 4.27309 2.0625 7 2.0625V0.5625C3.44467 0.5625 0.5625 3.44467 0.5625 7H2.0625ZM7 2.0625C9.72691 2.0625 11.9375 4.27309 11.9375 7H13.4375C13.4375 3.44467 10.5553 0.5625 7 0.5625V2.0625ZM6.25 3.9375V7H7.75V3.9375H6.25ZM7 7.75H10.0625V6.25H7V7.75Z",
    fill: "#0D1126"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_743_7248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.6cea18c92d38fd0ecfc77a50443736d0.svg";
export { ForwardRef as ReactComponent };